import { Action } from '@ngrx/store';

import { Skill } from '../creep-skill';

export const CREEP_SKILL = '[Creep] skill action';
export const CREEP_UNDO_ACTION = '[Creep] skill undo';
export const CREEP_ACTIONS = '[Creep] set history';

export class CreepSkillAction implements Action {
  readonly type = CREEP_SKILL;

  constructor(public payload: Skill) {}
}

export class CreepUndoAction implements Action {
  readonly type = CREEP_UNDO_ACTION;

  constructor() {}
}

export class CreepActions implements Action {
  readonly type = CREEP_ACTIONS;

  constructor(public payload: Skill[]) {}
}

export type Actions
  = CreepSkillAction
  | CreepUndoAction
  | CreepActions;



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/store.module/creep.actions.ts